import { stringifyQs } from "@saleor/utils/urls";

export const passwordResetPath = "/reset-password/"; // NOSONAR
export const passwordResetUrl = passwordResetPath;

export const passwordResetSuccessPath = "/reset-password/success/"; // NOSONAR
export const passwordResetInvalidPath = "/new-password/invalid/"; // NOSONAR
export const passwordResetSuccessUrl = passwordResetSuccessPath;

export const newPasswordPath = "/new-password/";
export const changePasswordPath = "/change-password";
export const updateEmailPath = "/update-email";

export const loginCallbackPath = "/";

export interface NewPasswordUrlQueryParams {
  email: string;
  token: string;
}
export const newPasswordUrl = (params?: NewPasswordUrlQueryParams) =>
  newPasswordPath + "?" + stringifyQs(params);

export interface LoginOpenidconnectUrlQueryParams {
  code: string;
  state: string;
}
export type LoginUrlQueryParams = LoginOpenidconnectUrlQueryParams;
